import React from 'react';

// project-imports
import { InstructorCourseSliderParams } from '../../utils/script';
import { GoogleAnalyticsEnum, pageView, triggerFunction } from '../../utils/google-analytics';
import SEO from '../../common/SEO';
import Skill from '../../components/progressbar/ProgressbarItem';
import Layout from '../../common/Layout';
import CourseTypeTwo from '../../components/course/CourseTypeTwo';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import { updatedInstructor } from '../../utils/teatimonial';

// third-party
import { useSelector } from 'react-redux';
import Avatar from 'react-avatar';
import { useParams, Link } from 'react-router-dom';
import Slider from 'react-slick';
import CountUp from 'react-countup';
import TrackVisibility from 'react-on-screen';


// Reading Enviroment Variable Start 
const LINKEDIN_URL = process.env.REACT_APP_LINKEDIN_URL;
const OFFICIAL_WEBSITE_URL = process.env.REACT_APP_OFFICIAL_WEBSITE_URL;
const YOUTUBE_CHANNEL_URL = process.env.REACT_APP_YOUTUBE_CHANNEL_URL;
const SALESFORCE_COURSE_DOMAIN = process.env.REACT_APP_SALESFORCE_COURSE_DOMAIN;
// Reading Enviroment Variable End

const InstructorDetails = () => {

    // Property initialization 
    const { id } = useParams();

    // Reading store data
    const instructorData = useSelector(state => state.instructor.instructorData);
    const courseData = useSelector(state => state.courses.courses);
    const testimonial = useSelector(state => state.testimonial.testimonials);


    // Constant variable 
    const data = instructorData && instructorData.length && instructorData.filter(instructor => instructor.id === id);
    const instructorsData = data && data.length && data[0];
    const teamMember = updatedInstructor(instructorsData, testimonial, courseData);
    const instructorNameForGA = GoogleAnalyticsEnum.INSTRUCTOR_DETAILS + " " + teamMember.name;
    const courses = courseData && courseData.length && courseData.filter(course => course.instructorId === id);
    let instructorCourseSliderParams = { ...InstructorCourseSliderParams, slidesToShow: courses.length < 2 ? courses.length : 2 }

    return (
        <>
            {pageView(window.location.pathname, instructorNameForGA)}

            <SEO title={`Longswitch Academy Instructor ${teamMember.name}`} url={process.env.PUBLIC_URL + `/instructor-details/${teamMember?.id}`} image={teamMember?.image} /> {/* Set SEO title */}
            <Layout searchDisable={true}>
                <BreadcrumbOne
                    title="Instructor Profile" // Breadcrumb title 
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Instructor Profile"
                />
                <div className="edu-instructor-profile-area edu-section-gap bg-color-white pb-150">
                    <div className="container">
                        <div className="row g-5">
                            <div className="col-lg-4 pr-sm--55">
                                <div className="instructor-profile-left p-20">
                                    <div className="inner">
                                        <div className="thumbnail">
                                            <Avatar className='object-fit-cover' size='230' src={teamMember.image} round />
                                        </div>
                                        <div className="content">
                                            <h5 className="title">{teamMember.name}</h5>
                                            <span className="subtitle">{teamMember.designation}</span>
                                            <div className="contact-with-info">
                                                <p><span>Email:</span> <a href={`mailto:${teamMember.mail}`}>{teamMember.mail}</a></p>
                                                <p><span>Phone:</span> <a href={`tel:${teamMember.phone}`}>{teamMember.phone}</a></p>
                                            </div>
                                            <ul className="social-share bg-transparent justify-content-center medium-size">
                                                <li><a href={LINKEDIN_URL} target="_blank" rel="noreferrer" onClick={() => triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LSA_INSTRUCTOR_LINKEDIN_PROFILE_CLICKED)}><i className="icon-linkedin" ></i></a></li>
                                                <li><a href={OFFICIAL_WEBSITE_URL} target="_blank" rel="noreferrer" onClick={() => triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LSA_INSTRUCTOR_WEBSITE_LINK_CLICKED)}><i className="icon-Browser"></i></a></li>
                                                <li><a href={YOUTUBE_CHANNEL_URL} target="_blank" rel="noreferrer" onClick={() => triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LSA_INSTRUCTOR_YOUTUBE_CHANNEL_CLICKED)}><i className="icon-youtube" ></i></a></li>

                                            </ul>
                                            <div className="contact-btn">
                                                <Link to="/contact-us" className="edu-btn">Contact Me
                                                    <i className="icon-arrow-right-line-right"></i>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-8">
                                <div className="instructor-profile-right">
                                    <div className="inner">
                                        <div className="section-title text-start">
                                            <span className="pre-title">About Me</span>
                                            <h3 className="title">Hello, I’m {teamMember.name}</h3>
                                            <p className="description mt--40">{teamMember.details}</p>
                                        </div>

                                        {teamMember.experience && teamMember.experience.length > 0 &&
                                            <div className="edu-skill-style mt--65">
                                                <div className="section-title text-start mb--30">
                                                    <span className="pre-title">Skillset</span>
                                                    <h3 className="title">Courses Progress</h3>
                                                </div>
                                                <div className="rbt-progress-style-1 row g-5">
                                                    {teamMember.experience.map((progress, i) => (
                                                        <div className="col-lg-6" key={i}>
                                                            <TrackVisibility
                                                                once
                                                                className="single-progress"
                                                            >
                                                                {({ isVisible }) => isVisible &&
                                                                    isVisible ? <Skill progress={progress} isVisible={isVisible} /> : <></>}
                                                            </TrackVisibility>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        }

                                        {teamMember.features && teamMember.features.length > 0 &&
                                            <div className="course-statistic-wrapper bg-color-primary ptb--50 mt--65 radius-small">
                                                <div className="row align-items-center g-5">
                                                    {teamMember.features.map((item, i) => (
                                                        <div className="col-lg-4 colmd-6 col-12 line-separator" key={i}>
                                                            <div className="course-statistic text-center">
                                                                <div className="inner">
                                                                    <TrackVisibility once>
                                                                        {({ isVisible }) => isVisible && item.isDecimal !== true ? <span className="total"><CountUp end={item.numbers} duration={1} delay={.1} start={0} /></span> : ''

                                                                        }
                                                                    </TrackVisibility>
                                                                    <TrackVisibility once>
                                                                        {({ isVisible }) => isVisible && item.isDecimal === true ? <span className="total"><CountUp end={item.numbers} duration={1} delay={.1} start={0} decimals={1} /></span> : ''

                                                                        }
                                                                        <p>{item.title}</p>
                                                                    </TrackVisibility>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        }

                                        {courses && courses.length > 0 &&
                                            <div className="edu-course-wrapper pt--65">
                                                <div className="section-title text-start mb--20">
                                                    <span className="pre-title">Courses</span>
                                                    <h3 className="title">Courses By : {teamMember.name}</h3>
                                                </div>
                                                <Slider
                                                    className="instructor-profile-courses course-activation course-activation-item-2 slick-gutter-15 edu-slick-button"
                                                    {...instructorCourseSliderParams}
                                                >
                                                    {
                                                        courses.map((course) => (
                                                            <div key={course.id} className="eduvibe-course-two-single">
                                                                <CourseTypeTwo data={course} coursesDomain={SALESFORCE_COURSE_DOMAIN} />
                                                            </div>
                                                        ))
                                                    }
                                                </Slider>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}
export default InstructorDetails;